import React from "react";
import ReactDOM from "react-dom/client";
import "primereact/resources/primereact.css"; // core css
import "./styles/style.css";
import { PrimeReactProvider } from "primereact/api";
import { BrowserRouter } from "react-router";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./authConfig";
import App from "./App";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { AppInsightsErrorBoundary, ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { UserProvider } from "./shared/GlobalContext";
import Tailwind from "primereact/passthrough/tailwind";
import "./styles/tailwindcss/components.css";
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    enableAutoRouteTracking: true,
    extensions: [reactPlugin],
    connectionString: `${import.meta.env.VITE_INSIGHTS_INSTRUMENTATION_KEY}`,
  },
});
appInsights.loadAppInsights();
await msalInstance.initialize();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ pt: Tailwind }}>
      <BrowserRouter>
        {" "}
        <MsalProvider instance={msalInstance}>
          <UserProvider>
            <AppInsightsErrorBoundary onError={() => <div></div>} appInsights={reactPlugin}>
              <App />
            </AppInsightsErrorBoundary>
          </UserProvider>
        </MsalProvider>
      </BrowserRouter>
    </PrimeReactProvider>
  </React.StrictMode>
);
